// Утилиты для стилей и форматирования

// Получение цвета категории
export const getCategoryColor = (categoryName) => {
  const colorMap = {
    'Красная икра': 'bg-red-500',
    'Свежая рыба': 'bg-blue-400',
    'Соленая и копченая рыба': 'bg-amber-700',
    'Креветки и лангустины': 'bg-orange-500',
    'Моллюски': 'bg-cyan-600',
    'Консервы': 'bg-gray-600',
  };
  return colorMap[categoryName] || 'bg-gray-500';
};

// Получение Tailwind класса цвета категории
export const getCategoryColorClass = (categoryName) => {
  const colorMap = {
    'Красная икра': 'bg-category-red-caviar',
    'Свежая рыба': 'bg-category-fresh-fish',
    'Соленая и копченая рыба': 'bg-category-salted-fish',
    'Креветки и лангустины': 'bg-category-shrimp',
    'Моллюски': 'bg-category-mollusks',
    'Консервы': 'bg-category-canned',
  };
  return colorMap[categoryName] || 'bg-gray-500';
};

// Получение цвета для прогресса
export const getProgressColor = (percentage) => {
  if (percentage >= 100) return 'bg-progress-complete';
  if (percentage >= 51) return 'bg-progress-high';
  if (percentage >= 1) return 'bg-progress-medium';
  return 'bg-progress-none';
};

// Форматирование цены
export const formatPrice = (price) => {
  return new Intl.NumberFormat('ru-RU', {
    style: 'currency',
    currency: 'RUB',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(price);
};

// Форматирование веса
export const formatWeight = (weight, unit = 'кг') => {
  if (unit === 'кг') {
    return `${weight} кг`;
  } else if (unit === 'г') {
    return `${weight} г`;
  }
  return `${weight} ${unit}`;
};

// Вычисление общей суммы корзины
export const calculateCartTotal = (items) => {
  return items.reduce((total, item) => total + (item.price * item.quantity), 0);
};

// Генерация уникального ID
export const generateId = () => {
  return Date.now().toString(36) + Math.random().toString(36).substr(2);
};

/**
 * Склонение единиц измерения по числу (русский язык)
 * "1 банка", "2 банки", "5 банок"
 */
export const pluralizeUnit = (n, unit) => {
  const num = Math.abs(n);
  const forms = {
    'кг': ['кг', 'кг', 'кг'],
    'банка': ['банка', 'банки', 'банок'],
    'шт': ['шт', 'шт', 'шт'],
    'упак': ['упаковка', 'упаковки', 'упаковок'],
    'л': ['л', 'л', 'л'],
    'г': ['г', 'г', 'г'],
  };
  const unitForms = forms[unit] || [unit, unit, unit];
  const lastTwo = num % 100;
  const lastOne = num % 10;
  if (lastTwo >= 11 && lastTwo <= 19) return unitForms[2];
  if (lastOne === 1) return unitForms[0];
  if (lastOne >= 2 && lastOne <= 4) return unitForms[1];
  return unitForms[2];
};

/**
 * Винительный падеж единицы ("за банку", "за упаковку")
 */
export const accusativeUnit = (unit) => {
  const accusative = {
    'кг': 'кг',
    'банка': 'банку',
    'шт': 'шт',
    'упак': 'упаковку',
    'л': 'л',
    'г': 'г',
  };
  return accusative[unit] || unit;
};